export default "__VITE_ASSET__CKNN1MqD__"